<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon>
          </v-btn>
          <span>Edit Device</span>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="6">
              <v-text-field
                v-model="form.serial_number"
                outlined
                label="Serial Number *"
                prepend-inner-icon="mdi-barcode"
                :error-messages="errors.serial_number"
              ></v-text-field>
            </v-col>
            <v-col sm="6">
              <v-text-field
                v-model="form.model_name"
                outlined
                label="Model Name"
                prepend-inner-icon="mdi-cellphone"
                :error-messages="errors.model_name"
              ></v-text-field>
            </v-col>
            <v-col sm="6">
              <v-autocomplete
                v-model="form.status"
                outlined
                label="Device Status"
                :items="deviceStatuses"
                item-text="text"
                item-value="value"
                prepend-inner-icon="mdi-toggle-switch"
                :error-messages="errors.status"
              ></v-autocomplete>
            </v-col>
            <v-col sm="6">
              <v-autocomplete
                v-model="form.hospital_id"
                outlined
                label="Hospital"
                :items="hospitals"
                item-text="name"
                item-value="id"
                prepend-inner-icon="mdi-hospital-building"
                :error-messages="errors.hospital_id"
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col sm="6">
              <v-switch
                class="mt-0 ml-5"
                v-model="form.is_active"
                inset
                :label="`Is Active: ${form.is_active ? 'YES' : 'NO'}`"
              ></v-switch>
            </v-col>
          </v-row>
          <v-row class="mt-4">
            <v-col>
              <v-btn
                :loading="isLoading"
                :disabled="isLoading"
                color="primary"
                rounded
                dark
                @click="save"
                class="mr-2"
              >
                Update Device
              </v-btn>
              <v-btn
                v-if="form.status == 0"
                :loading="isAssigning"
                :disabled="isAssigning"
                color="orange"
                rounded
                dark
                @click="assignDevice"
                class="mr-2"
              >
                <v-icon left>mdi-check</v-icon>
                Assign Device
              </v-btn>
              <v-btn
                v-if="form.status == 1"
                :loading="isMakingAvailable"
                :disabled="isMakingAvailable"
                color="green"
                rounded
                dark
                @click="makeDeviceAvailable"
                class="mr-2"
              >
                <v-icon left>mdi-refresh</v-icon>
                Make Available
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import axios from "@/axios";
export default {
  name: "DeviceEditPage",
  data() {
    return {
      form: {
        serial_number: "",
        model_name: "",
        status: 0,
        hospital_id: null,
        is_active: true,
      },
      hospitals: [],
      deviceStatuses: [
        { text: "Available", value: 0 },
        { text: "Assigned", value: 1 },
        { text: "Under Maintenance", value: 2 },
      ],
      isLoading: false,
      isAssigning: false,
      isMakingAvailable: false,
    };
  },
  computed: {
    errors() {
      return this.$store.getters['errors/getErrors'];
    },
  },
  mounted() {
    this.getData();
    this.getHospitals();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let encryptedId = this.$route.params.deviceId;
      try {
        const response = await axios.get(`/devices/${encryptedId}`);
        this.form = { ...response.data.data };
        this.isLoading = false;
      } catch (error) {
        console.error("Error fetching data:", error);
        this.isLoading = false;
        this.$router.back();
      }
    },
    async getHospitals() {
      try {
        const response = await axios.get("devices/hospitals");
        this.hospitals = response.data.data;
      } catch (error) {
        console.error("Error fetching hospitals:", error);
      }
    },
    async save() {
      try {
        this.isLoading = true;
        let encryptedId = this.$route.params.deviceId;
        const response = await axios.patch(`/devices/${encryptedId}`, this.form);
        this.form = response.data.data;
        this.isLoading = false;
        this.$toast.success("Device updated successfully!");
        this.$router.back();
      } catch (error) {
        console.error("Error updating device:", error);
        this.isLoading = false;
      }
    },
    async assignDevice() {
      try {
        this.isAssigning = true;
        let encryptedId = this.$route.params.deviceId;
        const response = await axios.post(`/devices/${encryptedId}/assign`);
        this.form = response.data.data;
        this.isAssigning = false;
        this.$toast.success("Device assigned successfully!");
      } catch (error) {
        console.error("Error assigning device:", error);
        this.isAssigning = false;
        this.$toast.error("Failed to assign device");
      }
    },
    async makeDeviceAvailable() {
      try {
        this.isMakingAvailable = true;
        let encryptedId = this.$route.params.deviceId;
        const response = await axios.post(`/devices/${encryptedId}/make-available`);
        this.form = response.data.data;
        this.isMakingAvailable = false;
        this.$toast.success("Device made available successfully!");
      } catch (error) {
        console.error("Error making device available:", error);
        this.isMakingAvailable = false;
        this.$toast.error("Failed to make device available");
      }
    },
  },
};
</script>